<div class="delete-request">
    <div class="delete-request__info">
        <img src="/assets/icons/delete-request.svg" width="36" height="36" alt="Delete">

        <p>
            <strong>{{data?.fullName}}</strong> {{'requests.delete' | translate}}
        </p>
    </div>

    <div class="delete-request__controls">
        <a [routerLink]="[data?.userId]" class="view-btn">
            {{'buttons.view' | translate}}
        </a>
        <svg role="button" (click)="removeAlert()" class="remove" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L6 3.87868L9.43934 0.43934C10.0251 -0.146447 10.9749 -0.146447 11.5607 0.43934C12.1464 1.02513 12.1464 1.97487 11.5607 2.56066L8.12132 6L11.5607 9.43934C12.1464 10.0251 12.1464 10.9749 11.5607 11.5607C10.9749 12.1464 10.0251 12.1464 9.43934 11.5607L6 8.12132L2.56066 11.5607C1.97487 12.1464 1.02513 12.1464 0.43934 11.5607C-0.146447 10.9749 -0.146447 10.0251 0.43934 9.43934L3.87868 6L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934Z" fill="#8E8F98"/>
        </svg>
    </div>
</div>